"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _videoPlayer = _interopRequireDefault(require("./video-player"));

var _default = _videoPlayer.default;
exports.default = _default;